import React from "react";

const stats = [
  {
    number: "250+",
    label: "Happy Clients",
  },
  {
    number: "500+",
    label: "Projects Completed",
  },
  {
    number: "99.9%",
    label: "Uptime & Support",
  },
  {
    number: "15+",
    label: "Years of Experience",
  },
];

const CounterStats = () => {
  return (
    <section className="bg-white py-16 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-10">Our Impact</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
          {stats.map((item, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="text-4xl font-bold text-accent">{item.number}</div>
              <div className="text-gray-600 mt-2 text-sm">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CounterStats;
